import { ReadXlsxWorkflowNode } from '@blaze-shared/workflow-domain';

import {
  ConnectorProvider,
  WorkflowNodeConnectorProvider,
} from '../../registry/connector-provider.registry';

@WorkflowNodeConnectorProvider('ReadXlsx')
export class ReadXlsxConnectorProvider extends ConnectorProvider<ReadXlsxWorkflowNode> {}
